import { createContext as createContext$1, useContext } from 'react';
import useMount from '../useMount/index.js';
import Logger from '../services/logger/index.js';

var fakeDefaultState = Symbol('defaultState');
function createContext(defaultState, contextName, withConsole) {
  var context = /*#__PURE__*/createContext$1(fakeDefaultState);
  var useContext$1 = function useContext$1(withoutDropContext) {
    var result = useContext(context);
    var isDefault = result === fakeDefaultState;
    useMount(function () {
      if (!withoutDropContext && isDefault) {
        Logger.error("".concat(contextName, ": context provider is missing"), withConsole);
      }
    });
    return isDefault ? defaultState : result;
  };
  return {
    context: context,
    useContext: useContext$1
  };
}

export { createContext as default };
//# sourceMappingURL=index.js.map
